import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UsersTable } from "../../../components/users/UsersTable";
import { UserGroupsTable } from "../../../components/user-group/UserGroupsTable";
import { Plus } from "lucide-react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

const Users = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(() => {
    return searchParams.get('tab') || location.state?.activeTab || "user";
  });

  useEffect(() => {
    document.title = "Users & User Groups | Admin";
  }, []);

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  // Update URL when tab changes
  useEffect(() => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('tab', activeTab);
    navigate(`?${newSearchParams.toString()}`, { replace: true });
  }, [activeTab]);

  const handleAddNew = () => {
    const currentSearchParams = searchParams.toString();
    if (activeTab === "user") {
      navigate("/admin/users/add", {
        state: { returnParams: currentSearchParams, activeTab }
      });
    } else {
      navigate("/admin/users/groups/add", {
        state: { returnParams: currentSearchParams, activeTab }
      });
    }
  };

  return (
    <div id="users_page_container" className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 id="users_page_title" className="text-3xl font-bold text-foreground">Users & User Group</h1>
          <p className="text-muted-foreground mt-2">Configure and manage users and Users group</p>
        </div>
        <Button id="users_page_add_btn" onClick={handleAddNew} className="bg-yellow-500 hover:bg-yellow-600 text-black px-6">
          <Plus className="h-4 w-4" />
          {activeTab === "user" ? "Add New User" : "Add New User Group"}
        </Button>
      </div>

      <Tabs defaultValue="user" value={activeTab} onValueChange={setActiveTab} className="w-full">
        <div className="flex items-center justify-between">
          <TabsList id="users_page_tabs_list" className="grid w-fit grid-cols-2 bg-transparent p-0 h-auto">
            <TabsTrigger 
              id="users_page_tab_user"
              value="user" 
              className="data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary rounded-none pb-4 px-6"
            >
              User
            </TabsTrigger>
            <TabsTrigger 
              id="users_page_tab_user_group"
              value="user-group"
              className="data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary rounded-none pb-4 px-6"
            >
              User Group
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent id="users_page_tab_content_user" value="user" className="mt-6">
          <UsersTable />
        </TabsContent>

        <TabsContent id="users_page_tab_content_user_group" value="user-group" className="mt-6">
          <UserGroupsTable />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Users;